<div class="d-flex align-items-center justify-content-center h-100 w-100 flex-column">
  <i class="ri-emotion-sad-line ri-10x"></i>
  <h1>403</h1>
  <span i18n="@@access-denied">Kein Zugriff – du hast keine Berechtigung für diese Seite.</span>
</div>